<template>
	<div class="pfbg">
		<div class="paixu_con">
			<div class="a px-24">
				<h4 class="font-18 text-center mb-0">{{title}}</h4>
			</div>
			<div class="ts" v-if="tcType == 'tishi'">
				<div v-html="miaoshu" class="text-center"></div>
			</div>
			<div class="ts" v-else-if="tcType == 'input'">
				<input type="text" class="ts_inp" :placeholder="placeholder" v-model="inp_val" />
			</div>
			<div class="c d-flex j-center a-center px-24">
				<el-button class="w-92" @click="addClick('close')">取消</el-button>
				<el-button class="w-92" type="warning" @click="addClick('ok')">确定</el-button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "tanchuang",
		props: {
			title: {
				type: String,
				default: "温馨提示"
			},
			miaoshu: {
				type: String,
				default: ''
			},
			tcType: {
				type: String,
				default: 'tishi'
			},
			placeholder: {
				type: String,
				default: '请输入新内容'
			},
		},
		data() {
			return {
				inp_val: ''
			}
		},
		methods: {
			addClick(e, item = '') {
				var that = this
				if (e == 'ok') {
					if (that.tcType == 'input') {
						if (!that.inp_val) {
							that.$toast('请输入新内容');
							return
						}
						that.$emit('tcClick', {
							sta: 'ok',
							val: that.inp_val
						})

					} else {
						that.$emit('tcClick', 'ok')
					}
				} else if (e == 'close') {
					that.$emit('tcClick', 'close')
				}

			},

		}
	}
</script>

<style lang="scss" scoped>
	.pfbg {
		position: fixed;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, .6);
		z-index: 2001;
	}

	.paixu_con {
		position: absolute;
		width: 500px;
		background-color: #fff;
		left: 50%;
		top: 50%;
		z-index: 1002;
		border-radius: 10px;
		overflow: hidden;
		transform: translate(-50%, -50%);

		.a {
			background-color: #F9F9F9;
			padding: 20px 24px;
		}

		.ts {
			background-color: #fff;
			font-size: 16px;
			line-height: 2;
			padding: 30px;

			.ts_inp {
				border: #ddd solid 1px;
				width: 100%;
				height: 40px;
				text-indent: 1em;
				border-radius: 3px;
				font-size: 16px;
			}
		}

		.c {
			height: 64px;
			background: #f9f9f9;
		}
	}

	.text-center {
		text-align: center;
	}
</style>